// extracted by mini-css-extract-plugin
export var footer = "index-module--footer--1UNE0";
export var socialIcon = "index-module--socialIcon--3AEVJ";
export var copyright = "index-module--copyright--1NNc_";